const INIT_FILTER_VALUE = {
  title: null,
  short_detail: null,
  category: null,
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
};

// mutations
const mutations = {
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
};
const getters = {
  getAllFilter: (state) => {
    return state;
  },
  getFilterSummaryArray: (state) => {
    let prepareState = { ...state };
    let result = [];
    // address
    if (prepareState.title)
      result.push({
        title: "หัวข้อข่าว",
        text: prepareState.title,
      });
    if (prepareState.category)
      result.push({
        title: "ประเภทข่าว",
        text: prepareState.category,
      });
    if (prepareState.short_detail)
      result.push({
        title: "รายละเอียดโดยย่อ",
        text: prepareState.short_detail,
      });
    return result;
  },
  getFilterForApi: (state) => {
    const result = {};
    if (state.title) result.TITLE = state.title;
    if (state.category) result.CATEGORY = state.category;
    if (state.short_detail) result.SHORT_DETAIL = state.short_detail;
    return result;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
